module.exports = __webpack_public_path__ + "static/media/img02.eae1bafc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/04/01/assets/img02.jpg
// module id = 514
// module chunks = 0